import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const submitContact = (payload) =>
  axios.post(`${API}/leads/contact`, payload).then((r) => r.data);

export const submitDemo = (payload) =>
  axios.post(`${API}/leads/demo`, payload).then((r) => r.data);
